import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import neo4j from 'neo4j-driver';
import { auditTime } from 'rxjs/operators';
import { Subject } from 'rxjs';
import {
  takeUntil,
  debounceTime,
  distinctUntilChanged,
  switchMap,
} from 'rxjs/operators';
import { Graph_Search } from 'src/app/services/neovis.service';
import { EnvService } from 'src/app/services/env.service';
import { InitQuerys } from '../neovis-graph/utils/neo4j-querys';

@Component({
  selector: 'app-create-search-dialog',
  templateUrl: './create-search-dialog.component.html',
  styleUrls: ['./create-search-dialog.component.css'],
})
export class CreateSearchDialogComponent implements OnInit {
  investigationType: any;
  neo4jSearchType: string = 'Analytiko'; // or 'AT37' or 'Analytiko'
  referenceInput: FormControl = new FormControl();
  cedulas: string[] = [];
  cuentas: string[] = [];
  casos: string[] = [];
  descripcion: string;
  constructor(public dialogRef: MatDialogRef<CreateSearchDialogComponent>) {}
  driver;
  public session;
  documents: string[];

  private destroy$ = new Subject<void>();
  ngOnInit(): void {
    this.initOptions();
    // Subscribe to changes in the search input field
    this.referenceInput.valueChanges
      .pipe(
        auditTime(1000),
        debounceTime(1000),
        distinctUntilChanged(),
        switchMap((searchValue: string) => {
          return this.getOptions(searchValue);
        }),
        takeUntil(this.destroy$)
      )
      .subscribe((data: any) => {
        console.log(data);
        let { cuentas, cedulas, casos } = data;
        this.cuentas = cuentas;
        this.cedulas = cedulas;
        this.casos = casos;
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Initializes the list of options for the search input field
   */
  async initOptions() {
    let { cuentas, cedulas, casos } = await this.getOptions('');
    this.cuentas = cuentas;
    this.cedulas = cedulas;
    this.casos = casos;
  }

  async runQuery(
    query: string,
    processRecord: (record: any) => any
  ): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this.session
        .run(query)
        .then((result) => {
          const results = result.records.map(processRecord);
          resolve(results);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  /**
   * Retrieves the list of options for the search input field based on the search query
   * @param search The search query
   * @returns A Promise that resolves to an array of strings representing the search options
   */
  async getOptions(search: string): Promise<any> {
    let env = new EnvService();
    // Create a new Neo4j driver and session
    this.driver = neo4j.driver(
      env.URL_NEO4J,
      neo4j.auth.basic('neo4j', 'password')
    );
    this.session = this.driver.session();
    let neo4jQuerys = InitQuerys(search);

    let qcuentas = neo4jQuerys.AT_37_default_search_match_account;
    if (search != '') qcuentas = neo4jQuerys.AT_37_search_match_account;

    let qcedulas = neo4jQuerys.AT_37_default_search_match_customer;
    if (search != '') qcedulas = neo4jQuerys.AT_37_search_match_customer;

    let qcasos = neo4jQuerys.AN_default_search_cases;
    if (search != '') qcasos = neo4jQuerys.AN_search_cases;

    // Función para procesar "cuentas"
    const processCuentas = (record: any) =>
      `${record._fields[0].properties.id}`;
    const cuentas = await this.runQuery(qcuentas, processCuentas);

    // Función para procesar "cedulas"
    const processCedulas = (record: any) =>
      `${record._fields[0].properties.Nombre} - ${record._fields[0].properties.id}`;
    const cedulas = await this.runQuery(qcedulas, processCedulas);

    // Función para procesar "casos"
    const processCasos = (record: any) =>
      `${record._fields[0].properties.gai} - ${record._fields[0].properties.numero_de_identificacion}`;
    const casos = await this.runQuery(qcasos, processCasos);

    return { cuentas, cedulas, casos };
  }

  /**
   * Creates a new Graph_Search object with the selected search options and passes it back to the parent component
   */
  onCreateClick(investigationType): void {
    const graph_search: Graph_Search = {
      reference: this.referenceInput.value,
      investigationType,
      description: this.descripcion,
    };
    // Close the dialog and pass the Graph_Search object back to the parent component
    this.dialogRef.close(graph_search);
  }
}
